// Lib
import React from 'react';
import { Typography } from '@mui/material';

// Hooks
import useUI from '../../../hooks/useUI';

import { useStyles } from './TitleContainerStyles';

const TitleContainer = ({
  fullName,
  isApproved,
  title = 'Approvals',
  message = 'The order quantity needs to be approved.',
}) => {
  const { classes } = useStyles({ isApproved });
  const { isMobileMode } = useUI();

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography className={classes.h1} variant="h1">
          {title}
        </Typography>
        <Typography className={classes.fullName} variant="h2">
          {isMobileMode && <div className={classes.circle} />}
          {fullName}
        </Typography>
      </div>
      {!isApproved && <p className={classes.approveText}>{message}</p>}
    </>
  );
};

export default TitleContainer;
